import type {
  FunnelSection,
  FunnelStageKey,
} from 'containers/user/critical-elements-monitoring/critical-elements-monitoring.types';

export const getStageVolume = (
  section: FunnelSection | undefined,
  stageKey: FunnelStageKey
): number | undefined =>
  section?.stages.find((stage) => stage.stageKey === stageKey)?.volume
    .current ?? undefined;
